"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.deployCanonicals = exports.isCanonicalDeployed = void 0;
const ethers_1 = require("ethers");
const _0_safe111AndFactoryConfig_json_1 = __importDefault(require("./txs/0_safe111AndFactoryConfig.json"));
const _1_safe120Config_json_1 = __importDefault(require("./txs/1_safe120Config.json"));
// see: https://etherscan.io/address/0x1aa7451dd11b8cb16ac089ed7fe05efa00100a6a
const _2_setImplementation_json_1 = __importDefault(require("./txs/2_setImplementation.json"));
const _3_multisend_json_1 = __importDefault(require("./txs/3_multisend.json"));
const _4_setImpl_json_1 = __importDefault(require("./txs/4_setImpl.json"));
const _5_createAndAddModules_json_1 = __importDefault(require("./txs/5_createAndAddModules.json"));
const _6_setImpl_json_1 = __importDefault(require("./txs/6_setImpl.json"));
const _7_createCall_json_1 = __importDefault(require("./txs/7_createCall.json"));
const _8_seImpl_json_1 = __importDefault(require("./txs/8_seImpl.json"));
const _9_defaultHandlerConfig_json_1 = __importDefault(require("./txs/9_defaultHandlerConfig.json"));
const _10_setImpl_json_1 = __importDefault(require("./txs/10_setImpl.json"));
const debug_1 = __importDefault(require("debug"));
const log = debug_1.default("CANONICAL_DEPLOY");
const DEPLOYER_ADDR = '0x1aa7451dd11b8cb16ac089ed7fe05efa00100a6a';
async function isCanonicalDeployed(provider) {
    try {
        await checkCode(provider, _1_safe120Config_json_1.default.safeAddress, _1_safe120Config_json_1.default.runtimeCode);
    }
    catch (e) {
        if (e.message.includes('NotExpectedError')) {
            return false;
        }
        throw e;
    }
    const txCount = await provider.getTransactionCount(DEPLOYER_ADDR);
    if (txCount < 11) {
        return false;
    }
    return true;
}
exports.isCanonicalDeployed = isCanonicalDeployed;
async function deployCanonicals(signer) {
    const funder = signer;
    const provider = signer.provider;
    if (!provider) {
        throw new Error("provider is undefined");
    }
    const isExpectedNonce = async (expected) => {
        const nonce = await provider.getTransactionCount(DEPLOYER_ADDR);
        if (nonce === expected) {
            return true;
        }
        log(`expected nonce ${expected} but was ${nonce}`);
        return false;
    };
    const deploy111AndFactory = async () => {
        const nonce = await provider.getTransactionCount(_0_safe111AndFactoryConfig_json_1.default.deployer);
        if (nonce != 0) {
            console.warn("Deployment account has been used on this network");
            return;
        }
        const deploymentCosts111AndFactory = ethers_1.BigNumber.from(_0_safe111AndFactoryConfig_json_1.default.deploymentCosts);
        const deploymentAccountBalance = await provider.getBalance(_0_safe111AndFactoryConfig_json_1.default.deployer);
        if (deploymentAccountBalance.lt(deploymentCosts111AndFactory)) {
            const tx = await funder.sendTransaction({
                to: _0_safe111AndFactoryConfig_json_1.default.deployer,
                value: deploymentCosts111AndFactory.sub(deploymentAccountBalance)
            });
            await tx.wait();
        }
        log("------ Deploy Safe 1.1.1 ------");
        await waitForTx(provider, _0_safe111AndFactoryConfig_json_1.default.deploymentTx);
        await checkCode(provider, _0_safe111AndFactoryConfig_json_1.default.safeAddress, _0_safe111AndFactoryConfig_json_1.default.runtimeCode);
        log("------ Execute Config Tx ------");
        await waitForTx(provider, _0_safe111AndFactoryConfig_json_1.default.configTx);
        log("------ Deploy Factory ------");
        await waitForTx(provider, _0_safe111AndFactoryConfig_json_1.default.factoryDeploymentTx);
        await checkCode(provider, _0_safe111AndFactoryConfig_json_1.default.factoryAddress, _0_safe111AndFactoryConfig_json_1.default.factoryRuntimeCode);
    };
    const deploy120 = async () => {
        log('deploy 1.2');
        const nonce = await provider.getTransactionCount(_1_safe120Config_json_1.default.deployer);
        if (nonce != 0) {
            console.warn("Deployment account for 1.2 already used");
            return;
        }
        const deploymentCosts120 = ethers_1.BigNumber.from(_1_safe120Config_json_1.default.deploymentCosts);
        const deploymentAccountBalance = await provider.getBalance(_1_safe120Config_json_1.default.deployer);
        log('price: ', ethers_1.utils.formatEther(deploymentCosts120.sub(deploymentAccountBalance)));
        if (deploymentAccountBalance.lt(deploymentCosts120)) {
            const tx = await funder.sendTransaction({
                to: _1_safe120Config_json_1.default.deployer,
                value: deploymentCosts120.sub(deploymentAccountBalance)
            });
            await tx.wait();
        }
        log("------ Deploy Safe 1.2.0 ------");
        await waitForTx(provider, _1_safe120Config_json_1.default.deploymentTx);
        await checkCode(provider, _1_safe120Config_json_1.default.safeAddress, _1_safe120Config_json_1.default.runtimeCode);
    };
    const deployTx = async (txConfig) => {
        if (!(await isExpectedNonce(txConfig.nonce))) {
            log('skipping');
            return;
        }
        const deploymentCostsDefaultHandler = ethers_1.BigNumber.from(txConfig.deploymentCosts);
        const deploymentAccountBalance = await provider.getBalance(txConfig.deployer);
        if (deploymentAccountBalance.lt(deploymentCostsDefaultHandler)) {
            log('sending ', deploymentCostsDefaultHandler.sub(deploymentAccountBalance).toString(), ' to deployer');
            const tx = await funder.sendTransaction({
                to: txConfig.deployer,
                value: deploymentCostsDefaultHandler.sub(deploymentAccountBalance)
            });
            await tx.wait();
        }
        log("------ deploy ------");
        await waitForTx(provider, txConfig.deploymentTx);
    };
    const chain = async (configs) => {
        log('deploying 2');
        let last = deployTx(configs[0]);
        for (let i = 1; i < configs.length; i++) {
            last = last.then(() => {
                log(`deploying ${i + 2}`);
                return deployTx(configs[i]);
            });
        }
        return last;
    };
    return deploy111AndFactory()
        .then(deploy120).then(() => {
        return chain([
            _2_setImplementation_json_1.default, _3_multisend_json_1.default, _4_setImpl_json_1.default, _5_createAndAddModules_json_1.default, _6_setImpl_json_1.default, _7_createCall_json_1.default, _8_seImpl_json_1.default, _9_defaultHandlerConfig_json_1.default, _10_setImpl_json_1.default
        ]);
    });
}
exports.deployCanonicals = deployCanonicals;
const waitForTx = async (provider, singedTx) => {
    const tx = await provider.sendTransaction(singedTx);
    const receipt = await tx.wait();
    log("confirmed. nonce/hash: ", tx.nonce, tx.hash);
    return receipt;
};
const checkCode = async (provider, address, expectedCode) => {
    const code = await provider.getCode(address);
    if (code !== expectedCode) {
        throw new Error(`NotExpectedError: ${expectedCode} != ${code}`);
    }
    log(`Deployment ${code === expectedCode ? "was successful" : "has failed"}`);
};
